/*
 * @Descripttion:
 * @version:
 * @Author: xiexing
 * @Date: 2020-05-13 16:14:35
 * @LastEditors: wangsen03 wangsen03@zhuanzhuan.com
 * @LastEditTime: 2024-11-05 19:14:23
 */
import Vue from 'vue'
import axios from '@lib/axios'
import API from '@/api/index'
import { env } from '@zz-yp/hunter-js-utils'

const state = {
  onePrice: {
    params: {
      brandId: '',
      modelId: '',
      modelIds: '',
      sortId: '',
      statusId: '',
      b2bGradeIds: '',
      keyword: ''
      // colorIds: '',
      // capacityIds: '',
      // versionIds: '',
      // sourceType: '',
      // memoryIds: '',
      // guaranteeIds: ''
    },
    saveParam: {},
    brandList: [], // 品牌数据
    modelList: [], // 型号数据
    topFilterList: [], // 筛选参数中需要置顶展示的参数项
    filterList: [], // 筛选参数
    attribute: [], // 属性筛选
    sortTitle: '',
    statusTitle: '', // 状态
    brandTitle: '', // 品牌文案
    modelTitle: '', // 型号文案
    gradeTitle: '',
    count: 0, // 等级个数
    timeTitle: '',
    resetVuexDataKeys: [] // 重置时需要重置的单元参数
  },
  redpackSummary: {
    redpackNum: 0,
    redpackTotalVal: 0,
    isDisplay: false,
    url: ''
  }
}

const mutations = {
  // 更改params
  SET_ONEPRICE_PARAMS: (state, params) => {
    const keys = Object.keys(params)
    keys.forEach((key) => {
      Vue.set(state.onePrice.params, key, params[key])
    })
  },
  SET_ONEPRICE_SAVE_PARAMS: (state, params) => {
    const keys = Object.keys(params)
    keys.forEach((key) => {
      Vue.set(state.onePrice.saveParam, key, params[key])
    })
  },
  // // 重置saveParam
  // SAVE_PARAMS_RESET: (state, params) => {
  //   Vue.set(state.secret.saveParam, 'labelIds', '')
  // },
  // 更改state
  SET_ONEPRICE_STATE: (state, params) => {
    Object.assign(state.onePrice, params)
  },
  // 重置params
  SET_ONEPRICE_RESET: (state) => {
    const keys = Object.keys(state.onePrice.params)
    const ignoreKeys = ['cateId', 'auctionType'] // 不需要重置的参数
    keys.forEach((key) => {
      if (ignoreKeys.indexOf(key) < 0) {
        Vue.set(state.onePrice.params, key, '')
      }
    })
    const stateKeys = Object.keys(state.onePrice)
    const resetKey = ['sortTitle', 'brandTitle', 'modelTitle', 'gradeTitle', 'statusTitle']
    stateKeys.forEach((key) => {
      if (resetKey.indexOf(key) >= 0) {
        Vue.set(state.onePrice, key, '')
      }
    })
    Vue.set(state.onePrice, 'modelList', [])
    Vue.set(state.onePrice, 'filterList', [])
  },
  // 重置属性参数
  ONEPRICE_FILTER_PARAMS_RESET: () => {
    state.onePrice.resetVuexDataKeys.forEach((key) => {
      Vue.set(state.onePrice.params, key, '')
      Vue.set(state.onePrice.saveParam, key, '')
    })
  },

  // 修改 redpackSummary
  SET_REDPACK_SUMMARY: (state, redpackSummary) => {
    state.redpackSummary = redpackSummary
  }
}

const actions = {
  updateRedpackSummary({ commit }, payload) {
    commit('SET_REDPACK_SUMMARY', payload)
  },

  resetRedpackSummary({ commit }) {
    commit('SET_REDPACK_SUMMARY', {
      redpackNum: 0,
      redpackTotalVal: 0,
      isDisplay: false,
      url: ''
    })
  },

  async queryRedpackSummary({ dispatch }) {
    try {
      const url = API.GET_REDPACK_SUMMARY
      const { redPackNum, redPackTotalVal, isDisplay, targetURLM, targetURLMiniApp } =
        await axios.get(url, {}, { ignoreLogin: true })
      dispatch('updateRedpackSummary', {
        redpackNum: redPackNum,
        redpackTotalVal: redPackTotalVal / 100,
        isDisplay,
        url: env.$isWechat ? targetURLMiniApp : targetURLM
      })
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
